"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSectionList = createSectionList;
const createConsultations_1 = require("./createConsultations");
const createCultures_1 = require("./createCultures");
const createImagingProcedures_1 = require("./createImagingProcedures");
const createLabProcedures_1 = require("./createLabProcedures");
const createMedicalHistory_1 = require("./createMedicalHistory");
const createScores_1 = require("./createScores");
const createVaccinationStatus_1 = require("./createVaccinationStatus");
const createViralSerology_1 = require("./createViralSerology");
function createSectionList(intl, options) {
    return [
        (0, createMedicalHistory_1.createMedicalHistory)(intl, options),
        (0, createLabProcedures_1.createLabProcedures)(intl, options),
        (0, createScores_1.createScores)(intl, options),
        (0, createCultures_1.createCultures)(intl, options),
        (0, createImagingProcedures_1.createImagingProcedures)(intl, options),
        (0, createConsultations_1.createConsultations)(intl, options),
        (0, createViralSerology_1.createViralSerology)(intl, options),
        (0, createVaccinationStatus_1.createVaccinationStatus)(intl, options)
    ];
}
